/** Formats a slug by:
 *  - replacing hyphens with spaces
 *  - replacing double hyphens with single hyphens
 *  - capitalizing text
 *
 * @param {string} slug - the unformatted amount. Example: amlodipine-besylate, azelastine--fluticasone
 * @returns {string} - the formatted amount. Example: Amlodipine Besylate, Azelastine-Fluticasone
 */

export const unslugify = (slug: string): string =>
  `${slug
    .replace(/-/g, ' ')
    .replace(/ {2}/g, '-')
    .replace(/(^\w|\s\w|-\w)/g, function (text: string) {
      return text.toUpperCase();
    })}`;
